import { render, staticRenderFns } from "./UnityPlayerConfig.vue?vue&type=template&id=b4bb03ac&scoped=true&"
import script from "./UnityPlayerConfig.vue?vue&type=script&lang=js&"
export * from "./UnityPlayerConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bb03ac",
  null
  
)

export default component.exports